module.exports = __webpack_public_path__ + "static/media/supplements.bf25f2d8.jpg";